import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Silent global hook: if any URL carries `?ref=ORBIT-XXXXXX`, persist the
 * code into localStorage so it survives navigation and lands in the Checkout
 * page's referral state. One-time; non-destructive for existing codes.
 */
export default function ReferralCapture() {
  const location = useLocation();
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = (params.get('ref') || '').trim().toUpperCase();
    if (!code) return;
    const stored = localStorage.getItem('tw_ref_code');
    if (stored !== code) {
      localStorage.setItem('tw_ref_code', code);
    }
  }, [location.search]);
  return null;
}
